import { DatePipe, CommonModule } from '@angular/common';
import { Component, ViewChild, OnInit, NgModule, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApexNonAxisChartSeries, ApexPlotOptions, ApexChart, ApexFill, ChartComponent, ApexAxisChartSeries, ApexDataLabels, ApexYAxis, ApexXAxis, ApexTooltip, ApexStroke, ApexLegend, ApexTitleSubtitle, } from "ng-apexcharts";
import { NgApexchartsModule } from 'ng-apexcharts';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { DeviceUuidService } from 'src/app/shared/services/deviceuuidservices/device-uuid.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { environment } from 'src/environments/environment';
import { OneSignal } from 'onesignal-ngx';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { NewsUpdatesComponent } from 'src/app/shared/components/news-updates/news-updates.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-bootstrap/carousel';
interface DataPoint {
  date: string;
  values: number[]; // Array for four series
}
@Component({
  selector: 'app-dashboard-1',
  templateUrl: './dashboard-1.component.html',
  styleUrls: ['./dashboard-1.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, NewsUpdatesComponent, NgApexchartsModule,
    ModalModule, CarouselModule],
  providers: [DatePipe],
})
export class Dashboard1Component implements OnInit {

  @ViewChild("chart") chart!: ChartComponent;
  @ViewChild("pieChart") pieChart!: ChartComponent;
  // public chartOptions: any;
  public chartOptions: any = {
    series: [
      {
        name: 'Total Hours',
        data: []
      }
    ],
    chart: {
      height: 250,
      type: 'bar',
      toolbar: { show: false }
    },
    plotOptions: {
      bar: { horizontal: false, columnWidth: '60%' }
    },
    colors: ['#CEEED9'], // safe default
    grid: { show: false },
    xaxis: {
      title: { text: 'Days' },
      labels: { style: { colors: [], fontSize: '14px' } }
    },
    yaxis: {
      title: { text: 'Hours' },
      labels: { style: { colors: ['#000'], fontSize: '14px' } }
    },
    tooltip: {
      y: { formatter: (val: number) => `${val} hours` }
    },
    dataLabels: { enabled: false }
  };
  // public optionsProgress3: any;
  // public pieChartOptions: any;

  public optionsProgress3: any = {
    series: [0],  // safe default
    chart: {
      type: 'radialBar',
      height: 250
    },
    plotOptions: {
      radialBar: {
        hollow: { size: '70%' }
      }
    },
    colors: ['#20E647'],
    stroke: { lineCap: 'round' },
    fill: { type: 'solid' },
    title: { text: 'Progress' },
    subtitle: { text: '' },
    tooltip: { enabled: true },
    xaxis: { categories: [] },
    yaxis: {}
  };

  public pieChartOptions: any = {
    series: [0, 100],
    chart: {
      type: 'pie',
      height: 350
    },
    labels: ['Completed', 'Remaining'],
    colors: ['#CDCFFF', '#F9F9F9'],
    dataLabels: {
      enabled: false
    },
    legend: {
      show: false,
      position: 'bottom'
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          }
        }
      }
    ]
  };

  private allData: DataPoint[] = [];
  private categories: string[] = [];
    public pendingLeaves = 0;
  public rejectedLeaves = 0;
  showSpinner = true;
  user: any;
  deviceUuid: any;
  checkInDate: any;
  checkInTime: any;
  checkOutTime: any;
  att_total_hours: any;
  shiftRemainingTime: any;
  percentageInProgress: any;
  runningTimer: any;
  years_count: any;
  anniversary_count: string | undefined;
  refresh: any;
  birthday: any;
  att_shift_start_time: any;
  att_shift_end_time: any;
  org_lat: any;
  org_long: any;
  aniversarydays: any;
  aniversaryhours: any;
  aniversaryminutes: any;
  aniversaryseconds: any;
  previousAnniversaryDays: any;
  remaininghours: any;
  remainingminutes: any;
  remaininseconds: any;
  startdate: any;
  endDate: any;
  attendanceData: any;
  checkInDays: any;
  checkInArrayForGraph: any;
  checkOutDays: any;
  checkOutArrayForGraph: any;
  rangeData: any;
  barColors: any;
  totalHours: any;
  userWorkingHours: any;
  user_evalutaion: any;
  evaluation: any;
  percentageevaluation: any;
  lat = 0;
  long = 0;
  checkOutDate: any;
  userInfo: any;
  total_leaves: any;
  unpaid_leave: any;
  colormode: any;
  paidLeaves: any;
  unpaidLeaves: any;
  gallery: any;
  remainleaves: any;
  theme_id: any;
  media: any;
  user_role: any;
  roleType: any;
  mediaObject: any[] = [];
  isNewsUpdateShow = false;
  isMedia = false;
  isNewsUpdateModalShow = true;
  evaluation_date: any;
  latestAnnouncement: any;
  latestAnnoument: any;
  annouceDescription: any;
  showDescription = false;
  announcementfiles: any;
  constructor(
    private leaveService: LeaveService,
    private mediaService: MediaService,
    public dashboardService: DashboardService,
    public router: Router,
    private route: ActivatedRoute,
    private deviceUuidService: DeviceUuidService,
    private sharedmode: SharedModeService,
    private attendanceService: AttendanceService,
    public datepipe: DatePipe,
    private oneSignal: OneSignal,
    private http: HttpClient,
    private renderer: Renderer2
  ) {
    const userInfo = localStorage.getItem('user');
    if (userInfo != null) {
      this.user = JSON.parse(localStorage.getItem('user') || '') || '';
    }
    this.user_role = JSON.parse(this.user.user_role.user_roles)
    this.roleType = this.user_role?.role_type;
    if (this.roleType == 'Admin') {
      this.router.navigate(['/new-admin-dashboard']);
    }
    this.user_detail();
  }
  ngOnInit(): void {
    $('#sidebar-wrapper').hide();
    $('.navbar').hide();
    $('').hide();
    $('.top-navbar').show();
    this.deviceUuid = localStorage.getItem("userDeviceID_OneSignal_subcripptio")
    this.runningTimer = setInterval(() => { this.Running() }, 1000);
    const date = new Date();
    this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    this.checkTimer();
    this.initializeData();
    this.getAttendanceData();
    this.isSecondShiftEmployee();
    this.getAllLeaveData();
    this.user_refresh();
    this.getAnnouncement();

  }


  private initializeData() {
    // Populate with initial data for 31 days
    for (let i = 1; i <= 31; i++) {
      const date = i.toString();
      this.categories.push(date);
      this.allData.push({
        date,
        values: [
          Math.floor(Math.random() * 100), // Data for Series 1
          Math.floor(Math.random() * 100), // Data for Series 2
          Math.floor(Math.random() * 100), // Data for Series 3
          Math.floor(Math.random() * 100)  // Data for Series 4
        ]
      });
    }
  }
  private initializeProgressChart(): void {
    const totalDays = 365;
    const currentDays = this.aniversarydays;
    const progressPercentage = (currentDays / totalDays) * 100;

    this.optionsProgress3 = {
      chart: {
        height: 70,
        type: "bar",
        stacked: true,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "20%",
          borderRadius: 6, // Apply border radius to the main bar
          colors: {
            backgroundBarColors: ["#f7f5f5"], // Background bar color
            backgroundBarRadius: 6, // Apply the same border radius to the background bar
          },
        },
      },
      colors: ["#1DBFC8"], // Solid bar color
      stroke: {
        width: 0,
      },
      series: [
        {
          name: "Process 3",
          data: [progressPercentage],
        },
      ],
      fill: {
        // type: "solid", // Use solid fill
        colors: ["#1DBFC8"], // Single solid color
      },
      tooltip: {
        enabled: false,
      },
      xaxis: {
        categories: ["Process 3"],
      },
      yaxis: {
        max: 100,
      },
    };
  }




  public updateChartWithNewData(newData: number[], date: string) {
    // Expect newData to be an array of four numbers for the four series
    const existingData = this.allData.find(dp => dp.date === date);

    if (existingData) {
      // Update existing data
      existingData.values = newData; // Replace values with new data
    } else {
      // Add new data
      this.allData.push({ date, values: newData });
      this.categories.push(date);
    }

    // Show only the last 15 data points
    if (this.allData.length > 15) {
      this.allData.shift(); // Remove the oldest data
      this.categories.shift(); // Remove the oldest category
    }

    this.chart.updateSeries([
      {
        name: "Series 1",
        data: this.allData.map(data => data.values[0])
      },
      {
        name: "Series 2",
        data: this.allData.map(data => data.values[1])
      },
      {
        name: "Series 3",
        data: this.allData.map(data => data.values[2])
      },
      {
        name: "Series 4",
        data: this.allData.map(data => data.values[3])
      }
    ]);

    this.chart.updateOptions({
      xaxis: {
        categories: this.categories,
      }
    });
  }

  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value?.data?.user
      this.user = this.refresh;
      this.birthday = this.user.dob
      if (this.birthday) {
        const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        if (datePattern.test(this.birthday)) {
          const date = new Date(this.birthday);
          const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short' };  // Day and abbreviated month (e.g., "4 Aug")
          this.birthday = date.toLocaleDateString('en-GB', options); // Apply the formatting
        }
      }
      this.att_shift_start_time = this.user.shift_start_time;
      this.att_shift_end_time = this.user.shift_end_time;
      this.att_total_hours = this.user.total_working_hours || this.user.usershittime?.[0].total_working_hours
      this.org_lat = this.refresh?.organization?.address.latitude;
      this.org_long = this.refresh?.organization?.address.longitude
      localStorage.setItem('user', JSON.stringify(value?.data?.user));
      const test_user = localStorage.getItem("user");
      const user_role = JSON.parse(this.user.user_role.user_roles)
      // if (user_role?.role_type != "Admin") {
      //   this.router.navigate(['/user-dashboard']);
      // }

    })

  }
  checkTimer() {
    this.showSpinner = true;
    this.dashboardService.getTodayCheckIn().then((value) => {
      this.showSpinner = false;
      const userID = this.user?.id ?? "15500"
      this.oneSignal.login(String(userID)).then(value => {
      })

      if (localStorage.getItem('userDeviceID_OneSignal_subcripptio') == "" || localStorage.getItem('userDeviceID_OneSignal_subcripptio') == null) {
        //Get ID for Onesignla External ID
        const userID = this.user?.id ?? "15500"
        this.oneSignal.login(String(userID)).then(value => {
          const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
          if (userDeviceID_OneSignal_subcripptio.length > 5) {
            this.deviceUuid = userDeviceID_OneSignal_subcripptio
            localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
          }
        })
        const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
        if (userDeviceID_OneSignal_subcripptio.length > 5) {
          this.deviceUuid = userDeviceID_OneSignal_subcripptio
          localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
        }
      } else {
        this.deviceUuid = localStorage.getItem('userDeviceID_OneSignal_subcripptio')
      }
      if (value?.data != null) {
        this.checkInDate = value?.data?.date,
          this.checkInTime = value?.data?.check_in || '';
        this.checkOutTime = value?.data?.check_out || '';
        this.countdownTimeStart(this.checkInTime);

      }
      this.initializeProgressChart();

    });

  }

  // countdownTimeStart(time: string) {
  //   if (time != null && time != "" && time != undefined && (this.checkOutTime == "" || this.checkOutTime == null)) {
  //     this.runningTimer = setInterval(() => {
  //       // Get the current time
  //       const currentDate = new Date();

  //       // Parse the provided start time
  //       const month = currentDate.toLocaleString('default', { month: 'short' });
  //       const startTime = new Date(`${month} ${currentDate.getDate()} ${currentDate.getFullYear()} ${time}`);

  //       // Calculate the elapsed time in milliseconds
  //       const elapsed = currentDate.getTime() - startTime.getTime();

  //       if (elapsed >= 0) {
  //         // Convert elapsed time to hours, minutes, and seconds
  //         const hours = Math.floor((elapsed % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //         const minutes = Math.floor((elapsed % (1000 * 60 * 60)) / (1000 * 60));
  //         const seconds = Math.floor((elapsed % (1000 * 60)) / 1000);

  //         // Format with leading zeros
  //         const secondsWithZero = seconds < 10 ? "0" + seconds : seconds;
  //         const minutesWithZero = minutes < 10 ? "0" + minutes : minutes;

  //         // Update elapsed time
  //         this.remaininghours = hours.toString();
  //         this.remainingminutes = minutesWithZero;
  //         this.remaininseconds = secondsWithZero;
  //         this.shiftRemainingTime = `${hours}:${minutesWithZero}:${secondsWithZero}`;

  //         // Calculate progress percentage
  //         const totalElapsedSeconds = hours * 3600 + minutes * 60 + seconds;
  //         const maxShiftSeconds = this.att_total_hours * 3600;
  //         const percentage = (totalElapsedSeconds / maxShiftSeconds) * 100;

  //         // Update percentage only if less than 100
  //         if (percentage <= 100) {
  //           this.percentageInProgress = +percentage.toFixed(2);
  //         } else {
  //           this.percentageInProgress = 100; // Lock the percentage at 100
  //         }
  //       }
  //     }, 1000);
  //   } else {
  //     this.shiftRemainingTime = "00:00:00";
  //   }
  // }
  countdownTimeStart(time: string) {
    if (time != null && time != "" && time != undefined && (this.checkOutTime == "" || this.checkOutTime == null)) {
      this.runningTimer = setInterval(() => {
        // Get the current time
        const currentDate = new Date();

        // Parse the provided start time
        const month = currentDate.toLocaleString('default', { month: 'short' });
        const startTime = new Date(`${month} ${currentDate.getDate()} ${currentDate.getFullYear()} ${time}`);

        // Calculate the elapsed time in milliseconds
        const elapsed = currentDate.getTime() - startTime.getTime();

        if (elapsed >= 0) {
          // Dynamic allowed time (in milliseconds)
          const maxAllowedTime = this.userWorkingHours * 60 * 60 * 1000;

          // Stop the timer when the dynamic time limit is reached
          if (elapsed >= maxAllowedTime) {
            clearInterval(this.runningTimer);
            this.shiftRemainingTime = `${this.userWorkingHours.toString().padStart(2, '0')}:00:00`;
            this.percentageInProgress = 100; // Lock at 100%
            return;
          }
          // Convert elapsed time to hours, minutes, and seconds
          const hours = Math.floor((elapsed % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((elapsed % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((elapsed % (1000 * 60)) / 1000);

          // Format with leading zeros
          const secondsWithZero = seconds < 10 ? "0" + seconds : seconds;
          const minutesWithZero = minutes < 10 ? "0" + minutes : minutes;

          // Update elapsed time
          this.remaininghours = hours.toString();
          this.remainingminutes = minutesWithZero;
          this.remaininseconds = secondsWithZero;
          this.shiftRemainingTime = `${hours}:${minutesWithZero}:${secondsWithZero}`;

          // Calculate progress percentage
          const totalElapsedSeconds = hours * 3600 + minutes * 60 + seconds;
          const maxShiftSeconds = this.userWorkingHours * 3600;
          const percentage = (totalElapsedSeconds / maxShiftSeconds) * 100;
          // Update progress percentage (capped at 100%)
          this.percentageInProgress = Math.min(+percentage.toFixed(2), 100);
          // Update percentage only if less than 100
          // if (percentage <= 100) {
          //   this.percentageInProgress = +percentage.toFixed(2);
          // } else {
          //   this.percentageInProgress = 100; // Lock the percentage at 100
          // }
        }
      }, 1000);
    } else {
      this.shiftRemainingTime = "00:00:00";
    }
  }

  Running() {
    const countDownDate = new Date(this.user?.joining_date).getTime();

    this.anniversary_count = "1st"
    // Get today's date and time
    const now = new Date().getTime();
    let distance = now - countDownDate;
    distance = Math.abs(distance);
    let years_day = Math.floor(distance / (1000 * 60 * 60 * 24))
    years_day = Math.abs(years_day);
    // alert(years_day)
    if (years_day >= 365) {
      this.years_count = Math.floor(years_day / 365);
      years_day = years_day - (365.2 * this.years_count)
      years_day = 365 - years_day;
      years_day = Math.floor(years_day)
      years_day = Math.abs(years_day);
    } else {
      years_day = 365 - years_day;
      years_day = Math.floor(years_day)
      years_day = Math.abs(years_day);
    }
    this.aniversarydays = (years_day).toString();
    this.aniversaryhours = (24 - Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).toString();
    this.aniversaryminutes = (60 - Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).toString();
    this.aniversaryseconds = (60 - Math.floor((distance % (1000 * 60)) / 1000)).toString();
    if (this.aniversarydays !== this.previousAnniversaryDays) {
      // Update the chart if the value has changed
      this.initializeProgressChart();
      // Update the previous anniversary days value
      this.previousAnniversaryDays = this.aniversarydays;
    }


    if (this.years_count === 1) {
      this.anniversary_count = "2nd"
    } else if (this.years_count === 2) {
      this.anniversary_count = "3rd"
    } else if (this.years_count > 2) {
      this.anniversary_count = this.years_count + "th"
    }

  }
  getAttendanceData() {
    this.attendanceService.getAttendance(
      this.startdate?.replace(new RegExp('-', 'g'), '/'),
      this.endDate?.replace(new RegExp('-', 'g'), '/'),
      null,
      null
    ).then((value) => {
      this.attendanceData = value.data.attendance;
      this.rangeData = [];  // Initialize array for range data

      this.attendanceData.forEach((x: any) => {
        // if (x?.check_in && x?.check_out) {
        // Extract day label and total hours for each day
        const dayLabel = new Date(x?.date).getDate().toString();
        this.totalHours = x?.total_hours;  // Total hours recorded for the day
        this.userWorkingHours = Number(x?.usershittime?.total_working_hours);  // Expected working hours

        // Add data for the bar chart with label and total hours
        this.rangeData.push({
          x: `${dayLabel}`,
          y: this.totalHours // Use total hours as the y-value for the bar
        });
        // }
      });

      // Set up the chart options with rangeData and a dynamic color function
      this.chartOptions = {
        series: [
          {
            name: 'Total Hours',
            data: this.rangeData
          }
        ],
        chart: {
          height: 250,
          type: 'bar',
          toolbar: {
            show: false // Disable the toolbar (menu bar)
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '60%'
          }
        },
        colors: [
          ({ dataPointIndex }: { dataPointIndex: number }) => {
            const totalHours = this.attendanceData[dataPointIndex]?.total_hours;
            const userWorkingHours = Number(this.attendanceData[dataPointIndex]?.usershittime?.total_working_hours);
            const overtime = this.attendanceData[dataPointIndex]?.overtime;
            if (overtime == null || overtime == undefined || overtime == 0) {
              if (userWorkingHours > totalHours) {
                return "#F6CECE";
              } else if (totalHours >= userWorkingHours) {
                return "#CEEED9";
              } else {
                return "#FFBF42";
              }
            } else {
              return "#DBC1E8";
            }
          }
        ],
        grid: {
          show: false,
        },
        xaxis: {
          title: {
            text: 'Days',
            style: {
              color: '#FF0000', // Red color for X-axis title
              fontSize: '14px'
            }
          },
          labels: {
            style: {
              colors: Array(this.rangeData.length).fill('#FF0000'), // Red color for each label on the X-axis
              fontSize: '14px'
            }
          }
        },
        yaxis: {
          title: {
            text: 'Hours',
            style: {
              color: '#FF0000', // Red color for Y-axis title
              fontSize: '14px'
            }
          },
          labels: {
            style: {
              colors: ['#FF0000'], // Red color for Y-axis labels
              fontSize: '14px'
            }
          }
        },
        tooltip: {
          y: {
            formatter: (val: number) => `${val} hours`
          }
        },
        dataLabels: {
          enabled: false // Hides the data labels
        }
      };

    });
    this.getData()
  }

  filterBars(filterType: string) {
    // Filter attendance data based on the selected filter
    const filteredData = this.attendanceData
      .map((x: any, index: number) => { // Track the index
        // if (x?.check_in && x?.check_out) {
        const totalHours = x?.total_hours;
        const userWorkingHours = Number(x.usershittime?.total_working_hours);
        const overtime = x?.overtime;
        let conditionMet = false;
        const hasCheckInOut = x?.check_in && x?.check_out;
        // Check for "overtime" filter
        if (filterType === 'overtime' && overtime > 0 && hasCheckInOut) {
          conditionMet = true;
        }
        // Check for "allGood" filter
        else if (filterType === 'shortTime' && userWorkingHours > totalHours && overtime === 0 && hasCheckInOut) {
          conditionMet = true;
        }
        // Check for "shortTime" filter
        else if (filterType === 'allGood' && totalHours >= userWorkingHours && overtime == 0 && hasCheckInOut) {
          conditionMet = true;
        }
        // Check for "all" filter, shows all data
        else if (filterType === 'all') {
          conditionMet = true;
        }

        // Return formatted item if condition is met
        if (conditionMet) {
          const dayLabel = new Date(x.date).getDate().toString();
          return {
            x: `${dayLabel}`,
            y: totalHours,
            index // Store the index for reference in color function
          };
        }
        // }
        return null; // Exclude items that don't meet the filter condition
      })
      .filter((item: any) => item); // Remove null values from array

    // Update the chart options with filtered data

    this.chartOptions = {
      ...this.chartOptions, // Preserve other chart options
      series: [
        {
          name: 'Total Hours',
          data: filteredData
        }
      ],
      colors: [
        ({ dataPointIndex }: { dataPointIndex: number }) => {
          const dataPoint = filteredData[dataPointIndex];
          if (!dataPoint) return "#FFBF42"; // Default color

          const totalHours = dataPoint.y;
          const correspondingAttendance = this.attendanceData[dataPoint.index]; // Use the filtered data index
          const userWorkingHours = Number(correspondingAttendance?.usershittime?.total_working_hours);
          const overtime = correspondingAttendance?.overtime;

          // Check for "allGood" condition
          if (totalHours >= userWorkingHours && overtime === 0) {
            return "#CEEED9"; // Color for "All Good"
          }

          // Check for "shortTime" condition
          if (userWorkingHours > totalHours && overtime === 0) {
            return "#F6CECE"; // Color for "Short Time"
          }

          // Check for "overtime" condition
          if (overtime > 0) {
            return "#DBC1E8"; // Color for "Overtime"
          }

          // Default color
          return "#FFBF42"; // Color for other cases
        }
      ]
    };
  }




  getData() {
    this.dashboardService.getDashboardData().then((value) => {
      this.mediaObject = value?.media;
      if (value?.media != null && value?.media != undefined && value?.media?.length > 0) {
        this.isNewsUpdateShow = true;
      }
      this.user_evalutaion = value?.emp_evaluations;
      if (this.user_evalutaion?.length > 0) {
        const points = this.user_evalutaion[this.user_evalutaion?.length - 1]?.pm_points;
        this.evaluation_date = this.user_evalutaion[this.user_evalutaion?.length - 1]?.date;
        this.evaluation = value?.emp_evaluations[0]?.pm_points
        this.percentageevaluation = Math.max(0, Math.min(100, (this.evaluation / 10) * 100));
        this.calculateEvaluationProgress(this.percentageevaluation);
      }
    });
  }
  calculateEvaluationProgress(evaluation: any) {

    this.pieChartOptions = {
      chart: {
        type: 'pie',
        height: 350
      },
      series: [evaluation, 100],
      colors: ['#CDCFFF', '#F9F9F9'],
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false,
        position: 'bottom',
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
        }
      }]
    };
  }



  getCheckInDetail() {
    if (this.isAvaialbaletoCheckin()) {
      this.showSpinner = true
      this.getCurrentPosition().then((coords) => {
        this.showSpinner = false
        this.lat = coords.latitude;
        this.long = coords.longitude;

        const currentDate = new Date();
        const mn = currentDate.getMonth() + 1
        const month = (mn < 10) ? `0${mn}` : (mn)
        const checkInTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;
        const checkInDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;
        Swal.fire({
          iconHtml: ` <img style='width: 100% !important;' src=${this.getImageURL(this.lat, this.long)}  alt="image"  onerror="this.onerror=null; this.src='../../../assets/theme1/location-not-found.jpg';"  >`,
          title: `Please confirm if you’d like to Punch out at ${checkInTime} pm?`,
          // text: `Your Check In Time is  :  ${checkInTime} `,
          showCancelButton: false,
          confirmButtonText: "Yes, Punch In",
          showConfirmButton: true,
          cancelButtonText: "Not Now"
        }).then((checkout: any) => {
          if (checkout.value) {
            const model = {
              date: checkInDate,
              check_in: checkInTime,
              latitude: this.lat,
              longitude: this.long,
              org_lat: this.org_lat,
              org_long: this.org_long,
              device_id: this.deviceUuid,
              location: "Lahore",
              is_portal: 1,
              user_id: this.user.id,
              attendance_type_id: 4,
              lunch_id: 1,
              source: "web_portal",
              total_hours: 0
            };
            this.checkIn(model);
          }
        });
      }).catch((error) => {
        this.showSpinner = false
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
          title: `We are not able to get your Current Location, please try again!`,
          showConfirmButton: false,
          timer: 2000,
        })
      });
    }
    else {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
        title: `Check In Already Applied`,
        showConfirmButton: false,
        timer: 2000,
      })
    }
  }


  isAvaialbaletoCheckin(): boolean {
    if (this.isWFHAllowed()) {
      const checkout_count = this.checkOutTime?.length ?? 0
      const checkin_count = this.checkInTime?.length ?? 0
      if ((checkin_count == 0) && (checkout_count == 0)) {
        return true;
      } else if ((checkin_count > 0) && (checkout_count > 0)) {
        return true;
      } else {
        return false;
      }
    }
    return false

  }

  getCurrentPosition(): Promise<{ latitude: number, longitude: number }> {
    return new Promise((resolve, reject) => {

      if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition((position) => {
          const coords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          resolve(coords);
        }, (error) => {
          reject(error);
        });
      } else {
        //For Skan and WordSense
        //  const coords = {
        //   latitude: 0,
        //   longitude: 0
        // };
        // resolve(coords);

        //For Kodex
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }

  getImageURL(latitude: number, longitude: number): any {
    if ((latitude ?? 0) == 0 || (longitude ?? 0) == 0) {
      return '../../../../assets/images/no_Location.png'
    } else {
      return `https://maps.google.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=17&size=640x480&scale=4&markers=size:large%7Ccolor:orange%7C${latitude},${longitude}&key=${environment.GoogleMapKey}`
    }
  }
  checkIn(model: any) {
    this.showSpinner = true
    if (model.org_lat && model.org_long) {
      this.dashboardService.checkInFromPortal(model).then((result) => {
        this.showSpinner = false;
        if (result.success) {
          Swal.fire({
            iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: result.message,
            showConfirmButton: false,
            timer: 2000,
          });
          window.location.reload();
        } else {
          Swal.fire({
            iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
            title: result.message,
            showConfirmButton: false,
            timer: 2000,
          })
          this.showSpinner = false
        }
      });
    } else {
      this.showSpinner = false
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
        title: `We are not able to get your Current Location, please try again!`,
        showConfirmButton: false,
        timer: 2000,
      })
    }

  }
  isSecondShiftEmployee() {
    if (this.isWFHAllowed()) {
      return false
    }
    return true
  }
  // shouldShowPunchInOutButton(): boolean {
  //   if (this.user.tracker != 1) {
  //     return true
  //   }
  //   return false
  // }

  getCheckOutDetail() {
    this.showSpinner = true;
    this.dashboardService.getTodayCheckIn().then((value) => {
      this.checkInDate = value?.data?.date;
      this.checkInTime = value?.data?.check_in;
      this.checkOutTime = value?.data?.check_out;
      this.showSpinner = false;
      if (this.isAvaialbaletoCheckOut()) {
        this.getCurrentPosition().then((coords) => {
          this.showSpinner = false
          this.lat = coords.latitude;
          this.long = coords.longitude;
          const currentDate = new Date();
          const mn = currentDate.getMonth() + 1
          const month = (mn < 10) ? `0${mn}` : (mn)
          const checkOutTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;
          this.checkOutDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;
          if (this.checkInTime != "") {
            this.totalHours = Math.abs(new Date(`${this.checkOutDate} ${checkOutTime}`).getTime() - new Date(`${this.checkInDate} ${this.checkInTime}`).getTime()) / 36e5;
            this.totalHours = this.totalHours < 0 ? this.totalHours * (-1) : this.totalHours;
          }
          Swal.fire({
            iconHtml: ` <img style='width: 100% !important;' src=${this.getImageURL(this.lat, this.long)}  alt="image"  onerror="this.onerror=null; this.src='../../../assets/theme1/location-not-found.jpg';"  >`,
            title: 'Do you really want to Pounch out?',
            text: `Your Pounch Out Time is  :  ${checkOutTime} `,
            showCancelButton: true,
            confirmButtonText: "Yes, Pounch Out",
            showConfirmButton: true,
            cancelButtonText: "Not Now"
          }).then((checkout: any) => {
            if (checkout.value) {
              const model = {
                date: this.checkInDate,
                check_out: checkOutTime,
                check_in: "",
                total_hours: this.totalHours != 0 ? this.totalHours.toFixed(2) : 0,
                latitude: this.lat,
                longitude: this.long,
                location: "Lahore",
                is_portal: 1,
                user_id: this.user.id,
                attendance_type_id: 4,
                lunch_id: 1,
                source: "web_portal",
                org_lat: this.org_lat,
                org_long: this.org_long,
                device_id: this.deviceUuid,
              };
              this.checkOut(model);
            }
          });
        }).catch((error) => {
          this.showSpinner = false
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
            title: `We are not able to get your Current Location, please try again!`,
            showConfirmButton: false,
            timer: 2000,
          })
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
          title: `You are not allowed to check out at this moment, Please Check In First, Thanks.`,
          showConfirmButton: false,
          timer: 2000,
        })
      }

    })
  }
  shouldShowPunchIn(): boolean {
    return !this.checkInTime || !!this.checkOutTime; // Determine if Punch In should show
  }

  shouldShowPunchOut(): boolean {
    return !!this.checkInTime && !this.checkOutTime; // Determine if Punch Out should show
  }

  checkOut(model: any) {
    this.showSpinner = true
    this.dashboardService.checkOutFromPortal(model).then((result) => {
      if (result.success) {
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,
        })
        this.showSpinner = false
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,
        })
        this.showSpinner = false
      }
    });
  }
  isAvaialbaletoCheckOut(): boolean {
    if (this.isWFHAllowed()) {
      const checkin_count = this.checkInTime?.length ?? 0
      const checkout_count = this.checkOutTime?.length ?? 0
      if ((checkin_count > 0) && (checkout_count == 0)) {
        return true;
      } else {
        return false;
      }
    }
    return false
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value?.data
      this.colormode = this.userInfo?.color_mode
      this.total_leaves = this.userInfo?.total_leaves
      this.unpaid_leave = this.userInfo?.unpaid_leave
      this.sharedmode.setMode(this.colormode);
      this.theme_id = this.userInfo?.theme_id
      if (this.theme_id === 2) {
        this.renderer.addClass(document.body, 'dark-theme');
      } else {
        this.renderer.removeClass(document.body, 'dark-theme');
      }
      this.showSpinner = false;
    })
    this.showMedia();
  }
  isWFHAllowed(): boolean {
    const dayIndex = 0;
    if ((this.user.usershittime?.[dayIndex]?.work_from_home == '1' && this.user.tracker != 1) || (this.user.attandance_type != 'Normal' && this.user.tracker != 1)) {
      return true
    }
    return false
  }
  getAllLeaveData() {
    this.leaveService.getAllLeave().then((value) => {
      value.data.forEach((x: any) => {
        const obj = x;
        if (x.status == "approved") {
          if (x.leave_payment_status == "paid") {
            if (x.leave_type_id == 3) {
              if (x.shortLeave_hours) {
                this.paidLeaves = this.paidLeaves + (Math.round((Number(x.shortLeave_hours) / 8) * 100) / 100);

              }
              else {
                this.paidLeaves = this.paidLeaves + 0.5;
              }
            }
            else {
              const leaveDays = this.calculateDiff(x.start_date, x.end_date,)
              this.paidLeaves = this.paidLeaves + leaveDays;
            }
          }
        } else if (x.status == "rejected") {
          const leaveDays = this.calculateDiff(x.start_date, x.end_date)
          this.rejectedLeaves = this.rejectedLeaves + leaveDays;
        } else if (x.status === "pending") {
          if (x.leave_type_id == 3) {
            this.pendingLeaves += x.shortLeave_hours
              ? Math.round((Number(x.shortLeave_hours) / 8) * 100) / 100
              : 0.5;
          } else {
            this.pendingLeaves += this.calculateDiff(x.start_date, x.end_date);
          }
        } 
        // this.typeArr.push(obj)
      });

      this.showSpinner = false;
    });

    // Check if paidLeaves is NaN and assign 0 if it is
    if (isNaN(this.paidLeaves)) {
      this.paidLeaves = 0;
    }
    if (isNaN(this.unpaidLeaves)) {
      this.unpaidLeaves = 0;
    }
  }
  calculateDiff(data_1: any, data_2: any) {
    const date1 = new Date(data_1);
    const date2 = new Date(data_2);

    const days = Math.floor(
      (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
    );
    return days + 1;
  }

  // showMedia() {
  //   this.mediaService.showMedia().subscribe(response => {
  //     if (response.success) {
  //       const validMedia = response.data.filter((x: any) => x?.path !== 'nill');

  //       const shuffledMedia = validMedia.sort(() => Math.random() - 0.5);

  //       const selectedMedia = shuffledMedia.slice(0, 4);

  //       const galleryImages = document.querySelectorAll('.gallery-images-section img');

  //       selectedMedia.forEach((media:any, index:any) => {
  //         if (galleryImages[index]) {
  //           galleryImages[index].setAttribute('src', media.path);
  //         }
  //       });
  //     }
  //   });
  // }
  showMedia(): void {
    const newMedia: any[] = [];
    this.mediaService.showMedia().subscribe(
      (response: any) => {
        if (response.success && response.data?.length) {
          // Filter valid media paths
          newMedia.push(
            ...response.data.filter((item: any) => item?.path && item.path !== 'nill')
          );

          if (newMedia.length > 0) {
            // Shuffle the array to get random images
            const shuffledMedia = newMedia.sort(() => 0.5 - Math.random());

            // Select the first 4 random images
            this.media = shuffledMedia.slice(0, 5);
          } else {
            console.warn('No valid media paths were found.');
          }
        } else {
          console.warn('No data returned from the API.');
        }
      },
      (error) => {
        console.error('Error fetching media:', error);
      }
    );
  }

  getImagePath(): string {
    return `${environment.imageBaseURL}`;
  }
  remainingLeaves() {
    this.showSpinner = true;
    this.dashboardService.getRemainingLeaves().then((value) => {
      this.remainleaves = value.data.data
    })
    this.showSpinner = false;
  }



  getAnnouncement() {

    this.dashboardService.getAnnouncement().then((value) => {

      this.latestAnnoument = value?.data;
      this.annouceDescription = this.latestAnnoument?.description
      if (this.annouceDescription != '' && this.annouceDescription != null) {
        this.showDescription = true;
      }

      this.announcementfiles = this.latestAnnoument?.files

    });
  }

  isImage(file: string): boolean {
    return /\.(jpg|jpeg|png|gif)$/i.test(file);
  }

  // Check if file is video
  isVideo(file: string): boolean {
    return /\.(mp4|mov|ogg)$/i.test(file);
  }
  getReactions(reactionCounts: any): { type: string, count: number }[] {
    if (!reactionCounts) return [];
    return Object.keys(reactionCounts).map(type => ({
      type,
      count: reactionCounts[type]
    }));
  }

  // Map reaction type → image path
  getReactionImage(type: string): string {
    switch (type) {
      case 'wow': return 'assets/announcement/wow.svg';
      case 'love': return 'assets/announcement/heart.svg';
      case 'like': return 'assets/announcement/like.svg';
      case 'dislike': return 'assets/announcement/dislike.svg';
      case 'angry': return 'assets/announcement/angry.svg';
      case 'upset': return 'assets/announcement/upset.svg';
      case 'laugh': return 'assets/announcement/laugh.svg';
      default: return 'assets/announcement/like.svg';
    }
  }

  get firstFile(): string | null {
    return this.announcementfiles && this.announcementfiles.length > 0
      ? this.announcementfiles[0]
      : null;
  }


}
